// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__6-otz","active":"PopoverSharedStyle_active__l8xKM","backdrop":"PopoverSharedStyle_backdrop__4449I"};